module.exports = __webpack_public_path__ + "static/img/rank_97.12382c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_97.png
// module id = ueKC
// module chunks = 0